import { useSubsequentEffect } from '@carvana/vdp-react-hooks';
import { COOKIES } from '~/constants';
import { useHasAppliedTrade } from '~/contexts/SearchContext';
import BrowserCookies from '~/utilities/BrowserCookies';

export default function useToggleAppliedTradeCookie(): void {
  const hasAppliedTrade = useHasAppliedTrade();

  useSubsequentEffect(() => {
    if (hasAppliedTrade) {
      BrowserCookies.remove(COOKIES.hasAppliedTrade);
    } else {
      BrowserCookies.set(COOKIES.hasAppliedTrade, String(false));
    }
  }, [hasAppliedTrade]);
}
